import LoginPage from './LoginPage';
import React from 'react';
const LoginPageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/login',
			element: (
				<React.Suspense fallback={<>...</>}>
					<LoginPage />
				</React.Suspense>
			),
		},
	],
};

export default LoginPageConfig;
